import { render, staticRenderFns } from "./ViewOrderTask.vue?vue&type=template&id=7146b491&"
import script from "./ViewOrderTask.vue?vue&type=script&lang=js&"
export * from "./ViewOrderTask.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrderTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports